/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_Seats_UnlimitedInputs */

const cs_billing_plan_seats_unlimited = /** @type {(inputs: Billing_Plan_Seats_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez limitu uživatelů`)
};

const en_billing_plan_seats_unlimited = /** @type {(inputs: Billing_Plan_Seats_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited seats`)
};

/**
* | output |
* | --- |
* | "Unlimited seats" |
*
* @param {Billing_Plan_Seats_UnlimitedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_seats_unlimited = /** @type {((inputs?: Billing_Plan_Seats_UnlimitedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_Seats_UnlimitedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_seats_unlimited(inputs)
	return cs_billing_plan_seats_unlimited(inputs)
});